module.exports = __webpack_public_path__ + "static/media/legStrength.10a94962.png";